import { Component, OnInit, HostListener } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { UserService } from "./_services/user.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

export let AppHttpClient: HttpClient;



@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit {
  isLoginError: boolean = false;
  action: any;
  showLoader: any = true;
  title = "app";
  subDomain: string;
  constructor(
    private httpClient: HttpClient,
    private userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {


    AppHttpClient = this.httpClient;
    let objTime = (localStorage.getItem("userExpiry")) ? parseInt(localStorage.getItem("userExpiry")) : 3600;
    Observable.interval((objTime - 60) * 1000).subscribe(x => {
      this.getAPICredential();
    });
  }

  ngOnInit() {
    this.getSubdomain();
    if (localStorage.getItem("userToken") == null) {
      this.getAPICredential();
    }
    else {
      var currentDate = new Date();
      var storageDate = new Date(localStorage.getItem("userTime"));
      if (currentDate > storageDate) {
        this.getAPICredential();
      }

    }

  }

  getAPICredential() {
    this.userService.siteAuthentication().subscribe(
      (data: any) => {
        var dt = new Date();
        dt.setSeconds(dt.getSeconds() + parseInt(data.data.expires_in));
        localStorage.setItem("userToken", data.data.access_token);
        localStorage.setItem("userExpiry", data.data.expires_in);
        localStorage.setItem("userTime", String(dt));
        localStorage.setItem("siteData", JSON.stringify(data.data.site_data));
        localStorage.setItem("loginLogo", data.data.site_data.site_logo);
        //this.router.navigateByUrl(this.router.url);      
      },
      err => {
        console.log(err);
        this.isLoginError = true;
      }
    );
  }
  // clear localstorage on browser close when stay sign in false
  // @HostListener('window:beforeunload', ['$event'])

  //    clearLocalStorage($event){     
  //      if(localStorage.getItem('isStayLogIn')=='0') 
  //      {
  //       localStorage.removeItem('userID');
  //       localStorage.removeItem('userDetails');     
  //       localStorage.removeItem('userExpiry');
  //       localStorage.removeItem('userTime');
  //       localStorage.removeItem('userToken');
  //      }     

  //   } 
  @HostListener('window:beforeunload', ['$event'])
  checkOrder($event: any) {
    if (localStorage.getItem('isorder') == 'yes') {
      $event.returnValue = true;
    }
  }

  getSubdomain() {
    const domain = window.location.hostname;
    if (domain.indexOf('.') < 0 ||
      domain.split('.')[0] === 'login' || domain.split('.')[0] === '192' || domain.split('.')[0] === 'admin' || domain.split('.')[0] === 'www' || domain.split('.')[0] === 'beta' || domain.split('.')[0] === 'staging') {
      this.subDomain = '';
    } else {
      this.subDomain = domain.split('.')[0];
      let urlParts = domain.split('.');
      let baseDomain = urlParts.slice(0).slice(-(urlParts.length === 4 ? 3 : 2)).join('.');
      if(baseDomain === environment.PublicQuoteBuilder_URL) {
        // When the pathname does not start with '/builder/', then navigate to the builder otherwise no need
        if (window.location.pathname.startsWith('/builder')) {
        } else {
          this.router.navigate(['/builder']);
        }
      } else {
        this.router.navigate(['/store']);
      }
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/app.component.ts